import { Injectable } from "@angular/core";
import { map, tap, switchMap, filter, take } from "rxjs/operators";
import { BehaviorSubject, from, Observable, Subject } from "rxjs";

import { HTTP } from '@awesome-cordova-plugins/http/ngx';

@Injectable({
    providedIn: "root",
})
export class CepService {
    constructor(private http: HTTP) {}

    /**
     * Get CEP Data
     * @author André Ramos <oi@andreramos.dev>
     */
    getCepData(cep) {
        const url = `https://viacep.com.br/ws/${cep}/json/`;

        return this.http.sendRequest(url, {
            method: "get",
        });
    }
}
